import React, { type JSX } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthAppContext } from '../context/useAuthAppContext';
import { useLogger } from '../context/useLogger';
import PageLoadingComponent from './PageLoading';

type AnonymousRouteProps = {
  children: JSX.Element;
};

const AnonymousRoute: React.FC<AnonymousRouteProps> = ({ children }) => {
  const { isLoading: isAuthLoading } = useAuth0();
  const { isAuthenticated } = useAuthAppContext();
  const location = useLocation();
  const logger = useLogger();

  logger.debug('🚀 AnonymousRoute current location:', location.pathname, {
    isAuthenticated,
  });

  if (isAuthLoading) {
    return <PageLoadingComponent />;
  }

  // Cas des utilisateurs connectés pour des pages anonymes
  if (isAuthenticated) {
    // Redirection vers accueil si connecté
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AnonymousRoute;
